export const getMaxYValue = (maxV, minV, yTicksC) => {
    if (maxV === minV) return 100
    return maxV + ((maxV - minV) / yTicksC) * 2
}
export const getMinYValue = (maxV, minV, yTicksC) => {
    if (maxV === minV) return 0
    return minV - ((maxV - minV) / yTicksC) * 2
}
